// extracted by mini-css-extract-plugin
export var alternate = "styles-module--alternate--2S8js";
export var cta = "styles-module--cta--1VQ7k";
export var darkStickyCTA = "styles-module--darkStickyCTA--2TvmF";
export var emailCTA = "styles-module--emailCTA--hvwAx";
export var responseContainer = "styles-module--responseContainer--ksqth";
export var sticyCta = "styles-module--sticyCta--2xd3L";